import { getObject, setObject } from '@/services/localStorage';

const log = (...args) => console.log('[notifications-ctx]', ...args);

const currentUserContractId = window.USER_DATA_SNAPSHOT.cisloZmluvy;

export function getContext() {
    const ctx = loadConfig();
    if (ctx.token && !ctx.contractId && currentUserContractId) {
        ctx.contractId = currentUserContractId;
        store(ctx);
    }
    return ctx;
}

export function reset() {
    log('reset');
    store({});
}

export function storeToken(token) {
    log('storeToken', token);
    if (token) {
        const ctx = getContext();
        ctx.token = token;
        if (currentUserContractId) {
            ctx.contractId = currentUserContractId;
        }
        store(ctx);
    }
    return token;
}

export function storeSettings(updateObj) {
    log('storeSettings', updateObj);
    setObject('notifications.settings', Object.assign(loadSettings(), updateObj));
}

export function loadSettings() {
    log('loadSettings');
    return getObject('notifications.settings') || {};
}

function loadConfig() {
    log('loadConfig');
    let { contractId, token } = getObject('notifications.config') || {};
    return { contractId, token };
}

function store(ctx) {
    log('store', ctx);
    setObject('notifications.config', ctx);
}
